module.exports = __webpack_public_path__ + "img/manual.fb951759.svg";